<template>
  <div>
    <div class="eks-title">
      <div>{{ $t("RAM.AWS.eks.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="['resourceConfigurationManagement:aws:eks:update']"
          :loading="modal_loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="['resourceConfigurationManagement:aws:eks:export']"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="eks-top">
      <elastic-kubernetes-service-search
        ref="search"
      ></elastic-kubernetes-service-search>
    </div>
    <table-elastic-kubernetes-service></table-elastic-kubernetes-service>
  </div>
</template>

<script>
import ElasticKubernetesServiceSearch from "../eks/ElasticKubernetesServiceSearch";
import TableElasticKubernetesService from "../eks/TableElasticKubernetesService";

export default {
  name: "EKS",
  components: {
    ElasticKubernetesServiceSearch,
    TableElasticKubernetesService
  },
  data() {
    return {
      modal_loading: false,
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.companyId = this.$refs.search.companyId;

      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 24,
          accountType: 0
        })
        .then(res => {
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });

      // 获取子组件数据
      this.companyId = this.$refs.search.companyId;
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAwsEks({
          companyId: this.companyId,
          accountName: this.accountName,
          clusterName: this.clusterName
        })
        .then(res => {
          let fileName = "EKS.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.eks-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.eks-title > div:nth-child(1) {
  float: left;
}
.eks-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.eks-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/eks/EKS.vue